<template>
  <div class="common-layout">
    <el-container style="padding: 0;margin-top: -10px;width: 1905px;">
      <!-- 主导航栏 -->
      <el-header style=" height: 100px;">
        <el-row :gutter="0">
          <el-col :offset="2" :span="10" style="margin-top: 20px;">
            <img id="logoImg" :src="require('@/assets/logo.png')" width="221" height="63">
            <b class="logo-text">{{ $t('company') }}</b>
          </el-col>
          <el-col :offset="3" :span="6" style="margin-top: 2%;">
            <el-menu mode="horizontal" :default-active="activeMenu">
              <router-link to="/"> <el-menu-item index="/"> {{ $t('nav.home') }} </el-menu-item> </router-link>
              <router-link to="/about"><el-menu-item index="/about"> {{ $t('nav.about') }} </el-menu-item></router-link>
              <router-link to="/business"> <el-menu-item index="/business"> {{
                $t('nav.products') }}</el-menu-item></router-link>
              <router-link to="/contact"><el-menu-item index="/contact">{{ $t('nav.contact') }}
                </el-menu-item></router-link>
            </el-menu>
          </el-col>
          <el-col :span="2" style="margin-left: 0px; margin-top: 10px;">
            <!-- 顶部语言选择栏 -->
            <el-radio-group v-model="currentLocale" @change="changeLanguage">
              <el-radio-button label="en" :value="'en'">English</el-radio-button>
              <el-radio-button label="zh" :value="'zh'">中文</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer>
        <el-row justify="center" class="footer-info">
          <el-col class="version-info" :span="18">
            <el-row justify="center">
              <span>{{ $t('contcat.officeAddress') }}</span>
            </el-row>
            <el-row justify="center">
              <span>{{ $t('contcat.warehouseAddress') }}</span>
            </el-row>
            <p>中国注册商标 小程序 第1号目录 | 2015-03-06</p>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>

<script setup>
import { ref, onMounted, provide } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { watch } from 'vue'

const router = useRouter();
const { t, locale } = useI18n();

// 语言状态
const currentLocale = ref(locale.value);

// 提供全局语言状态
provide('locale', currentLocale);

// 监听路由变化更新活跃菜单项
const activeMenu = ref(router.currentRoute.value.path);
router.afterEach((to) => {
  activeMenu.value = to.path;
});

// 切换语言
const changeLanguage = (lang) => {
  currentLocale.value = lang;
  locale.value = lang;
  localStorage.setItem('locale', lang);
};

// 初始化时从本地存储加载语言
onMounted(() => {
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale) {
    currentLocale.value = savedLocale;
    locale.value = savedLocale;
  }
});
// 实现APP的高度占满全屏
// $('.main').height($(window).height())
</script>

<style scoped>
.language-bar {
  background-color: #f5f7fa;
  height: 30px;
  line-height: 30px;
}

.logo-text {
  color: #6dc7d5;
  font-size: 30px;
  text-align: center;
  /* 文字水平居中 */
  display: inline-block;
  /* 可选：让 text-align 生效 */
}

.el-main {
  padding: 0;
  width: 100%;
}


.footer-info {
  border-top: 1px solid #ebeef5;
  background-color: black;
}

.version-info {
  color: #ffffff;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.6;
  font-size: 12px;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;

}

.main {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
}

.common-layout {
  height: 100vh;
}
</style>